/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MdCommonModule} from '../core';
import {A11yModule} from '../core/a11y/index';
import {OverlayModule} from '../core/overlay/overlay-directives';
import {MdSidenav, MdSidenavContainer} from './sidenav';
export class MdSidenavModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule, MdCommonModule, A11yModule, OverlayModule],
  exports: [MdSidenavContainer, MdSidenav, MdCommonModule],
  declarations: [MdSidenavContainer, MdSidenav],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdSidenavModule_tsickle_Closure_declarations() {
/** @type {?} */
MdSidenavModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdSidenavModule.ctorParameters;
}



export {throwMdDuplicatedSidenavError,MdSidenavToggleResult,MdSidenav,MdSidenavContainer} from './sidenav';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
